import React, {Button, Component, useState } from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import EmptyPage from '../../widgets/EmptyPage';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import GetIntermediariesService from '../../services/getIntermediaries';
import GetCompaniesService from '../../services/getCompanies';
import Table from '../../widgets/tables/CompanyTable';
import WaitDialog from '../../widgets/WaitDialog';
import Select from 'react-select';
import ManageCompany from '../../services/manageCompany';
import CreateDirectory from '../../services/createDirectory';
import ZipFolder from '../../services/zipFolder';
//import PdfCompany from '../../utils/pdf/companySchedule';
import GetEvent from '../../services/getEvent';
import GetMeetings from '../../services/getMeetings';
import GetBreaks from '../../services/getBreaks';
import Constants from "../../utils/consts";
import moment from 'moment';
import PdfCompany from '../../utils/pdf/companyScheduleJSON';
import SendMailWidget from '../../widgets/SendMailWidget';
import SendMail from '../../services/sendMail';
import Utils from '../../utils/utils';
import SelectDateInterval from "../../widgets/SelectDateInterval";

const endLine = '\n';

export default class Companies extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.eventslist = [];
    this.selectRef = React.createRef();
    this.elementPdf = undefined;

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      mailCompaniesList: [], 
      isDatePickerVisible: false,
    }

    this.grid = 2;

    this.pdfElements = [];

    this.companiesList = [];
    this.pageTitle = "Companies";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });

    this.state = {

    };

  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentEventId = cookies.get('currentEventId', { path: '/' });
    this.event = await GetEvent(username, token, currentEventId);
    this.meetings = await GetMeetings(username, token, currentEventId);
    console.error(this.meetings);
    this.breaks = await GetBreaks(username, token, currentEventId);

    this.intermediaries = await GetIntermediariesService(username, token, currentEventId, 'company');
    this.options = [{value: 'All', label: 'All', id: undefined}];
    this.intermediaries.map((v) => {
      this.options.push({value: v.name, label: v.name, id: v.id});
    });

    var broker = '';
    if (this.brokerId != undefined) {
      broker = this.brokerId;
    }
    this.companiesList = await GetCompaniesService(username, token, currentEventId, broker);
    console.error(this.companiesList);


    this.companiesList.forEach(company => {
      var meetings = this.meetings.filter(m => { return m.company_id == company.id});
      let sortMeetings = meetings.sort((a, b) => {
        var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
        var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");

        return time1 - time2;
      });

      sortMeetings.forEach((a, index) => {
        if (index + 1 >= sortMeetings.length) return;
        var b = sortMeetings[index + 1];
        var time1 = moment(a.date + " " + a.hour+":"+a.minutes, "DD/MM/yyyy HH:mm");
        var time2 = moment(b.date + " " + b.hour+":"+b.minutes, "DD/MM/yyyy HH:mm");
        time1 = time1.add(a.slots * 5, 'minutes');
        if (time1 > time2){
          console.log('------------------------');
          console.log(company.name);
          console.log(a.date + ' ' + a.hour+":"+a.minutes);
          console.log(b.date + ' ' + b.hour+":"+b.minutes);
          alert ('ALARM: ' + company.name + ' ' + a.date + ' ' + a.hour+":"+a.minutes + b.date + ' ' + b.hour+":"+b.minutes + ' ' + a.id + ' ' + b.id);

        }

      });

    })


    this.setState({});
  }

  async componentDidMount(){
    await this.reload();

  }

  async onChange(value) {
    this.brokerId = value.id;
    await this.reload();
  }


  async savePdfIndex(dirName){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    var index = 0;
    while (index < this.companiesList.length){
      var company = this.companiesList[index];

      var json = cookies.get('checksList', { path: '/' });
      var checksList = json.list;
      if (checksList.length > 0){
        if (checksList.indexOf(company.id) == -1){
          index++;
          continue;
        }
      }

      
      this.pdfUrl = await PdfCompany.getAddress(this.event, company, this.breaks, this.meetings, dirName);
      this.setState({
        waitDialogVisible: true,
        index: index + '/' + (checksList.length > 0 ? checksList.length : this.companiesList.length)
      });
      index++;

    }
    await ZipFolder(username, token, dirName);
    //window.open(Constants.mainUrl+'/apis/files/'+dirName+'pdfs.zip', "_blank");
    window.location.href=Constants.mainUrl+'fixmeeting-pdfs/storage/app/public/pdf/'+dirName+'pdfs.zip';
    this.setState({waitDialogVisible: false});
  }


  resetCheckList (){
    const cookies = new Cookies();
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });
  }

  generateAllCompaniesPdf(startDate, endDate) {
      const cookies = new Cookies();
      cookies.set('pdfStartDate', startDate, { path: '/' });
      cookies.set('pdfEndDate', endDate, { path: '/' });
      cookies.set('scheduleType', 'allCompanies', { path: '/' });
      cookies.set('brokerId', "", { path: '/' });
      window.location.href= '#/app/pdfPage';
  }
  
  render () {

    const defaultFontValue = {
      fontFamily: 'Montserrat',
      fontSize: 21,
      color: '#555555'
    }

    var headCells = [
      { id: 'name', numeric: false, disablePadding: true, label: 'Company' },
      { id: 'country', numeric: true, disablePadding: false, label: 'Country' },
      { id: 'sector', numeric: true, disablePadding: false, label: 'Sector' },
      { id: 'email_address', numeric: true, disablePadding: false, label: 'Email address' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];

    function createData(name, website, country, phone_number, mobile_number) {
      return { name, website, country, phone_number, mobile_number};
    }

    var rows = [];
    this.eventslist.length > 0 && this.eventslist.map((v, k) => {
      rows.push(createData(v.name, v.website, v.username));
    });

    const cookies = new Cookies();
    const currentEventName = cookies.get('currentEventName', { path: '/' });

    if (currentEventName == '' || currentEventName == undefined){
      return <EmptyPage />;
    }

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title="Companies" button="ADD" secondButton="PRINT ZIP PDF" thirdButton="PRINT PDF SINGLE FILE" fourthButton="SEND SCHEDULE"
        
        onClick={() => {
          if (this.brokerId == undefined) {
            alert ("Please select an intermediary first");
            return;
          }

          const cookies = new Cookies();
          cookies.set('currentBroker', this.brokerId, { path: '/' });
          window.location.href = '/#/app/addcompany';

        }}

        onSecondClick={async () => {

          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });
          const dirName = await CreateDirectory(username, token) + '/';
         
          this.savePdfIndex(dirName);
        }}

        onThirdClick={async () => {

          this.setState({ isDatePickerVisible: !this.state.isDatePickerVisible });
        }}

        onFourthClick={async () => {

          var json = cookies.get('checksList', { path: '/' });
          var checksList = json.list;

          var mailList = this.companiesList;
          if (checksList.length > 0){
            mailList = mailList.filter(m => { return checksList.indexOf(m.id) != -1 });            
          }

          this.setState({
            sendMailVisible: true,
            mailCompaniesList: mailList
          });
        }}

        />

        <div >Intermediary:</div>
        <Select ref={this.selectRef} options={this.options} defaultValue={this.options[0]} onChange={this.onChange.bind(this)}/> <br/>

        <Table headCells={headCells} rows={this.companiesList} onEventClick={(row) => {
          cookies.set('currentCompany', row, { path: '/' });
          window.location.href = '/#/app/editcompany';
        }}

        onSendMail= {async (companyId) => {
          this.setState({
            sendMailVisible: true,
            mailCompaniesList: this.companiesList.filter((elem) => elem.id == companyId)
          });
        }}

        onDelete={async (companyId) => {
          if (window.confirm("Delete the company?")) {

            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });
      
            let res = await ManageCompany (username, token, companyId, 0, 0, 
              '', '', '', '', '', '', 
              '', '', '', '',
              '', '', '', '', '', '', true);

            if (!res || res.result !== 'ok'){
              alert ('An error occurred while deleting the company.')
            } else {
              this.reload();            
            }
          }
        }}

        onResetCheckList={() => {
          this.resetCheckList();
        }}

        onElementCheck={async (companyId) => {
          const cookies = new Cookies();

          var json = cookies.get('checksList', { path: '/' });
          var checksList = json.list;
          var index = checksList.indexOf(companyId);
          if (index != -1)
            checksList.splice(index, 1);
          else 
            checksList.push(companyId);

          cookies.set('checksList', JSON.stringify({list: checksList}), { path: '/' });
        }}

        />

        {this.elementPdf ? this.elementPdf : null}
        { this.state.sendMailVisible && (
        <SendMailWidget 
          show={this.state.sendMailVisible} 
          eventToSend={this.event}
          onClose={() => this.setState({sendMailVisible: false})}
          onSend={async (subject, body, sendStartDate, sendEndDate) => {
            var numProcessed = 0;
            var numErrors = 0;
            var messageLog = "";

            if (this.event.mailUser == '' || this.event.mailPassword == ''){
                alert ('You have to specify an address and a password in Event Details');
                return;
            }

            this.setState({waitDialogVisible: true, index:  numProcessed + '/' + this.state.mailCompaniesList.length})

            for (const company of this.state.mailCompaniesList) {

              if (company.email_address == undefined || company.email_address == "") {
                messageLog += company.name + ' NO MAIL DEFINED' + endLine;
                numProcessed++;
                numErrors++;

                this.setState({waitDialogVisible: true, index:  numProcessed + '/' + this.state.mailCompaniesList.length})
                continue;
              }

              for (const meeting of this.meetings) {
                
                // Cicle over all meetings and get the ones from the current company
                if (meeting.company_id == company.id) {
                    
                  // Get date value of this meeting
                  const meetingDateStr = meeting.date[3] + meeting.date[4] + "/" + meeting.date[0] + meeting.date[1] + "/" + meeting.date.slice(-4);
                  const meetingDate = new Date(meetingDateStr);

                  if (meetingDate >= sendStartDate && meetingDate <= sendEndDate) {
                    // This company needs to receive the email 
                    console.log("Send email to: " + company.id);
                    
                    /*
                    var from = "conference@cnroadshows.com";
                    var fromName = "Conference";
                    var password = "Povera_Matilde1"; 
                    */

                    var from = this.event.mailUser;
                    var fromName = this.event.mailUser;
                    var password = this.event.mailPassword;

                    var to = company.email_address.trim();
                    var cc = company.second_email_address.trim();
                    var more = company.more_emails.trim();
                    var bcc = from.trim();
                    var toName = company.name;
        
                    
                    try {
                      var attachmentPath = (await Utils.getPdfUrl('company', company.id)).replace('http://fixmeeting.eu/', '');
                      await SendMail('', '', from, fromName, password, to, more, cc, bcc, toName, attachmentPath, subject, body);
                      //messageLog += analyst.name + ' ' + to + ' SENT' + endLine;

                    } catch (error){
                      numErrors++;
                      messageLog += company.name + ' ' + to + ' ERROR' + endLine;
                    }

                    numProcessed++;
                    this.setState({waitDialogVisible: true, index:  numProcessed + '/' + this.state.mailCompaniesList.length});
                    
                    break;
                  } 
                }
              }
          }
          this.setState({waitDialogVisible: false})
          this.setState({sendMailVisible: false})

          alert ('ERRORS: ' + numErrors  + endLine + messageLog);
        }} /> )}

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        { this.state.isDatePickerVisible && (
            <SelectDateInterval
            startDate={this.event.startDate}
            endDate={this.event.endDate}
            onDone={(startDate, endDate) => {
              if(startDate != null && endDate != null) {

                var startDateStr = "";
                if (startDate.getDate() < 10) { startDateStr += "0" + startDate.getDate() + "-"; } else { startDateStr += startDate.getDate() + "-"; }
                if (startDate.getMonth() + 1 < 10) { startDateStr += "0" + (startDate.getMonth() + 1) + "-"; } else { startDateStr += (startDate.getMonth() + 1) + "-"; }
                startDateStr += startDate.getFullYear();

                var endDateStr = "";
                if (endDate.getDate() < 10) { endDateStr += "0" + endDate.getDate() + "-"; } else { endDateStr += endDate.getDate() + "-"; }
                if (endDate.getMonth() + 1 < 10) { endDateStr += "0" + (endDate.getMonth() + 1) + "-"; } else { endDateStr += (endDate.getMonth() + 1) + "-"; }
                endDateStr += endDate.getFullYear();
                
                console.log(startDateStr);
                console.log(endDateStr);

                this.generateAllCompaniesPdf(startDateStr, endDateStr);
              }
              this.setState({ isDatePickerVisible: false });
            }} />
        )}
        </LoadingOverlay>
      </>
    );
  }
}

